import { useState, useEffect } from "react";
import { ImSpinner } from "react-icons/im";
import { fetchData } from "../GlobalFunctions";
import { FaRegCopy } from "react-icons/fa";
import { toast } from "react-toastify";

function SystemPrompt() {
  interface SystemPrompt {
    id: string;
    prompt_name: string;
    prompt_text: string;
    type: string;
  }

  const [systemPrompt, setSystemPrompt] = useState<SystemPrompt[] | null>(null);

  useEffect(() => {
    fetchData(`${process.env.REACT_APP_SYSTEM_PROMPT}`, setSystemPrompt);
  }, []);

  return (
    <div>
      <div>
        {systemPrompt && systemPrompt.length > 0 ? (
          <div>
            {systemPrompt?.map((data) => (
              <div
                key={data.id}
                className={`relative  flex flex-col rounded-lg duration-300`}
              >
                <div className=" flex">
                  <p className=" text-[25px] pb-4">{data.prompt_name}</p>
                </div>
                <div className=" relative whitespace-break-spaces h-full overflow-y-scroll custom-scrollbar-chat p-4 bg-gray-300 rounded-md">
                  <button
                    className=" absolute top-2 right-2 p-2 bg-green-500 hover:bg-green-700 duration-300 rounded-md"
                    onClick={() => {
                      navigator.clipboard.writeText(data.prompt_text);
                      toast.success("Prompt has been copied successfully!", {
                        position: "top-center",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        theme: "dark",
                      });
                    }}
                  >
                    <FaRegCopy size={25} color="white" />
                  </button>
                  <pre className=" whitespace-break-spaces">
                    <code>{data.prompt_text}</code>
                  </pre>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex justify-center">
            <ImSpinner size={30} className=" animate-spin" />
          </div>
        )}
      </div>
    </div>
  );
}

export default SystemPrompt;
